/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'

@Component
export class SubportionOperationGuardMixin extends Vue {
    /// GUARD OPERATIONS ///

    $_canCreateSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.CREATE)
    }
    $_canEditSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.EDIT)
    }
    $_canDeleteSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.DELETE)
    }
    $_canCancelSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.CANCEL)
    }

    $_canPrintSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.PRINT)
    }
    $_canAttachDocumentToSubportion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.ATTACH)
    }

    $_canUndoLastSubportionOperation(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.UNDO)
    }

    $_canRequestAdditionalAssay(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.REQUEST_ADDITIONAL_ASSAY)
    }
    $_canRequestAdditionalScan(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.REQUEST_ADDITIONAL_SCAN)
    }
    $_canRequestPathologistReview(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.REQUEST_PATHOLOGIST_REVIEW)
    }
    $_canRequestAnySubportionRevision(): boolean {
        // add here new subportion revision types only when they are implemented in backend
        return this.$_canRequestAdditionalScan()
    }

    $_canTakeOutFromLaboratory(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.TAKE_OUT_FROM_LABORATORY)
    }

    /// CAN BE ///

    $_canBeSubportionCancelled(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBeCancelled
    }
    $_canBeSubportionDeleted(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBeDeleted
    }
    $_canBeSubportionPrinted(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBePrinted
    }
    $_canBeSubportionDiscarded(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBeDiscarded
    }
    $_canBeSubportionUnDiscarded(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBeUndiscarded
    }
    $_canBeAssayModifiedToSubportion(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canAssayBeModified
    }
    $_canBeAssayRequestedInParentPortionToSubportion(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canAssaysBeRequestedInParentPortion
    }
    $_canBeIncidentCreatedToSubportion(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canCreateIncidents
    }
    $_canBeDocumentAttachedToSubportion(subportion: any): boolean {
        return subportion?.metadata?.operationGuards.canBeAttached
    }
}
